import React from "react";
import Select, { components, DropdownIndicatorProps } from "react-select";

import { ReactComponent as ChevronDown } from "../../../../resources/icons/chevron-down.svg";

export interface Props {
    placeholder: string;
    value?: string;
    options: { value: string; label: string }[];
    onChange: (value: string | null) => void;
}

export function FstyrSelect({ onChange, options, placeholder, value }: Props) {
    const DropdownIndicator: React.FC<DropdownIndicatorProps> = (props) => {
        const {
            selectProps: { menuIsOpen }
        } = props;
        return (
            <components.DropdownIndicator {...props}>
                <ChevronDown
                    className={`transition-transform ${
                        menuIsOpen ? "rotate-180" : "rotate-0"
                    }`}
                />
            </components.DropdownIndicator>
        );
    };

    const selectedOption =
        options.find((entry) => entry.value === value) ?? null;

    return (
        <Select
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? "#024776" : "#D9E4EC",
                    fontFamily: "IBM Plex Sans; sans-serif",
                    borderRadius: "12px",
                    backgroundColor: "white",
                    "&:hover": {
                        borderColor: "#024776"
                    },
                    boxShadow: "none",
                    paddingLeft: "12px",
                    paddingRight: "12 px",
                    height: "56px",
                    fontSize: "16px"
                }),
                menu: (baseStyles, state) => ({
                    ...baseStyles,
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    borderRadius: "12px",
                    borderColor: "#024776",

                    zIndex: 9999
                }),
                option: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "white",
                    "&:hover": {
                        backgroundColor: "#ECF1F5"
                    },
                    color: "#263945",
                    fontFamily: "IBM Plex Sans; sans-serif",
                    fontSize: "16px",
                    zIndex: 9999
                }),
                indicatorSeparator: (baseStyles, state) => ({
                    ...baseStyles,
                    display: "none"
                })
            }}
            closeMenuOnSelect={true}
            value={selectedOption}
            components={{ DropdownIndicator }}
            placeholder={placeholder}
            isClearable={true}
            onChange={(newValue) => {
                let option = newValue as {
                    value: string;
                    label: string;
                };
                onChange(option?.value ?? null);
            }}
            options={[...options]}
        />
    );
}
